
const Loading = () => {
    return (
        <div className="h-fit flex items-center justify-center my-24">
            <div className="w-24 h-24 border-b-2 border-gray-900 rounded-full animate-spin"></div>
        </div>
    );
};

export default Loading;